import { render, staticRenderFns } from "./NoCampaigns.vue?vue&type=template&id=a42db766&scoped=true&"
var script = {}
import style0 from "./NoCampaigns.vue?vue&type=style&index=0&id=a42db766&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42db766",
  null
  
)

export default component.exports